import React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import Icon from 'components/UI/Icon';
import * as styles from './accordeon.module.scss';

const Accordeon = ({ accordeon }) => {
  return (
    <Accordion
      className={classnames(styles.accordion)}
      aria-level="4"
      preExpanded="0"
    >
      {accordeon.length > 0 &&
        accordeon.map((item, index) => {
          return (
            <AccordionItem
              uuid={index.toString()}
              key={item.accordeonTitle}
              className={classnames(styles.accordionItem)}
            >
              <AccordionItemHeading
                className={classnames(styles.accordionHeading)}
              >
                <AccordionItemButton
                  className={classnames(styles.accordionButton)}
                >
                  <h3 className={classnames('cr-h3')}>{item.accordeonTitle}</h3>
                </AccordionItemButton>
              </AccordionItemHeading>

              <AccordionItemPanel className={classnames(styles.accordionPanel)}>
                <div className={classnames(styles.panelText)}>
                  <p
                    className={classnames(
                      styles.panelText_description,
                      'cr-lead'
                    )}
                  >
                    {item.accordeonDescription}
                  </p>
                  <Link
                    to={item.url}
                    className={classnames(styles.panelText_link)}
                  >
                    <Icon name="corner-arrow-bg" />
                  </Link>
                </div>
                <div className={classnames(styles.mediaWrap)}>
                  <video
                    src={item.videoSrc}
                    autoPlay="autoplay"
                    loop="loop"
                    playsInline
                    muted
                    poster={item.poster}
                  ></video>
                </div>
              </AccordionItemPanel>
            </AccordionItem>
          );
        })}
    </Accordion>
  );
};

export default Accordeon;
